import React from 'react';
import { dateToString } from '../../Services/helpers';
import DateTime from './DateTime';


const RelativeDate = ({date, className}) => {
    if (!date) {
        return null;
    }

    const dateString = getDateString(date);

    if (dateString) {
        return <span className={className}>{dateString}</span>;
    }

    return <DateTime date={date} className={className} hideTime />;
}

const getDateString = (date) => {
    const today = dateToString(new Date());
    if (today === date) {
        return 'Today';
    }

    if (date > today) {

        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        if (dateToString(tomorrow) === date) {
            return 'Tomorrow';
        }

        for (let i = 0; i < 6; i++) {
            tomorrow.setDate(tomorrow.getDate() + 1);
            if (dateToString(tomorrow) === date) {
                return tomorrow.toLocaleDateString('en-GB', {weekday: 'long'});
            }
        }

    }

    return null;
}

export default RelativeDate;